
import Vue from 'vue';
import { mapGetters } from 'vuex';
import ServicesList from '../components/booking-page-services/ServicesList.vue';
import UpgradeToAccessDialog from '../components/dialogs/UpgradeToAccessDialog.vue';
import PremiumTag from '../components/PremiumTag.vue';
import { ACTIONS } from '../constants/actions';
import { GETTERS } from '../constants/getters';
import { APP_VUEX_MODULES } from '../constants/vuex-modules';
import CalearnaLogoAnimation from '../components/common/CalearnaLogoAnimation.vue';

export default Vue.extend({
  components: { ServicesList, PremiumTag, UpgradeToAccessDialog, CalearnaLogoAnimation },
  name: 'Services',
  created(): void {
    this.getServices();
  },
  computed: {
    ...mapGetters(APP_VUEX_MODULES.services, {
      loading: GETTERS.services.loading,
      services: GETTERS.services.getServices
    }),
    ...mapGetters(APP_VUEX_MODULES.bookings, {
      bookingPage: GETTERS.bookings.getSelectedBookingPage,
      isFreeAccount: GETTERS.bookings.isFreeAccount
    })
  },
  methods: {
    getServices(): void {
      const { dispatch } = this.$store;
      const bookingPageId = parseInt(this.$route.params.bookingPageId, 10);
      dispatch(ACTIONS.services.getServices, { bookingPageId });
    },
    checkAccount(): void {
      if (this.isFreeAccount) {
        this.showUpgradeToAccessDialog();
      } else {
        this.$router.push({ name: 'CreateService' });
      }
    },
    showUpgradeToAccessDialog(): void {
      const upgradeToAccessDialog = this.$refs.upgradeToAccessDialog as any;
      upgradeToAccessDialog.open(this.$tc('upgradeToPremium'), this.$tc('upgradeToAccessServices'));
    }
  }
});
